import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useFetch from '../../../../components/hooks/useFetch.js';
import SelectContratos from '../../../../components/form/SelectContratos.js';
import Select from '../../../../components/form/Select.js';
import MultiSelectCartoesPostagem from '../../../../components/form/MultiSelectCartoesPostagem.js';
import {
  PESQUISAR_CARTOES_CENTROCUSTO_PJ,
  PERMISSIONARIO_EDITAR_CARTOES,
  CARREGA_CARTOES,
  CARREGA_GRUPOS,
} from '../../../../services/delegacaoAcesso.js';
import { useForm } from 'react-hook-form';
import { getIPAddress } from '../../../../components/utils/GetIPAddress.js';
import { abreAlertaDialog } from '../../../../components/modal/AlertaDialog.js';
import ModalDialog from '../../../../components/modal/ModalDialog.js';
import './TelaDelegacaoInclusao.scss';
import FormSistemas from './FormSistemas.js';

const TelaDelegacaoEdicao = () => {
  const { register, handleSubmit, errors, control } = useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const { request } = useFetch();
  const [ipAddress, setIpAddress] = useState('');
  const dados = location.state.dados;
  const dadosPerfil = location.state.dadosPerfil;
  const dadosEmpresa = location.state.dadosEmpresa;
  const filtros = location.state.filtros;
  const usuario = location.state.usuario;
  const [contratoSelecionado, setContratoSelecionado] = useState();
  const [cartoesFiltrados, setCartoesFiltrados] = useState();
  const { request: requestCentroCusto, data: dadosCentroCusto } = useFetch();
  const [cartao, setCartao] = useState([]);
  const [cartaoAdicionado, setCartaoAdicionado] = useState([]);
  const [cartoesOriginais, setCartoesOriginais] = useState([]);
  const [modalAbertoSistemas, setModalAbertoSistemas] = useState(false);
  const [sistemasSelecionados, setSistemasSelecionados] = useState();
  const listaUsuario = [usuario.idCorreiosPF];
  const { request: requestCartoesCadastrados, data: dadosCartoesCadastrados } =
    useFetch();
  const { request: requestGruposCadastrados, data: dadosGruposCadastrados } =
    useFetch();
  useEffect(() => {
    if (usuario) {
      requestCartoesCadastrados(
        CARREGA_CARTOES(
          usuario.idCorreios,
          usuario.idCorreiosPF,
          dadosPerfil?.idCorreiosPF,
          dadosPerfil?.perfil,
        ),
      );
      requestGruposCadastrados(
        CARREGA_GRUPOS(
          usuario.idCorreios,
          usuario.idCorreiosPF,
          dadosPerfil?.idCorreiosPF,
          dadosPerfil?.perfil,
        ),
      );
    }
  }, [usuario]);

  useEffect(() => {
    if (dadosCartoesCadastrados) {
      setCartaoAdicionado(dadosCartoesCadastrados);
      setCartoesOriginais(dadosCartoesCadastrados);
    }
  }, [dadosCartoesCadastrados]);

  useEffect(() => {
    if (dadosGruposCadastrados) {
      setSistemasSelecionados(transformarLista(dadosGruposCadastrados));
    }
  }, [dadosGruposCadastrados]);

  const transformarLista = (gruposCadastrados) => {
    return gruposCadastrados.reduce((acc, { idSistema, idGrupo }) => {
      const sistemaExistente = acc.find((sistema) => sistema.id === idSistema);

      if (sistemaExistente) {
        sistemaExistente.grupos?.push({ idGrupo });
      } else {
        acc.push({
          id: idSistema,
          grupos: [{ idGrupo }],
        });
      }

      return acc;
    }, []);
  };

  const fechar = () => {
    setModalAbertoSistemas(false);
  };

  const abreModalSistamas = () => {
    setModalAbertoSistemas(true);
  };

  useEffect(() => {
    const fetchIPAddress = async () => {
      const ip = await getIPAddress();
      const port = window.location.port;
      setIpAddress(ip + ':' + port);
    };

    fetchIPAddress();
  }, []);

  const chamaDelegacaoAcesso = () => {
    const filtrosDelegacao = filtros;
    navigate('/delegacaoAcesso', {
      state: { dados: dados, dadosPerfil, filtrosDelegacao },
    });
  };

  useEffect(() => {
    if (contratoSelecionado) {
      requestCentroCusto(
        PESQUISAR_CARTOES_CENTROCUSTO_PJ(
          dados.idCorreios,
          dadosEmpresa.usuarioExternoPJ.cnpj
            ? dadosEmpresa.usuarioExternoPJ.cnpj
            : dadosEmpresa.usuarioExternoPJ.an8,
          contratoSelecionado,
        ),
      );
    } else {
      limpaCartoes();
    }
  }, [contratoSelecionado]);

  function limpaCartoes() {
    if (cartao) {
      setCartao([]);
    }
  }

  const handleEscolherCentroCusto = (event) => {
    limpaCartoes();
    const centroSelecionado = dadosCentroCusto.filter(
      (item) => item.coCentroCusto == event.target.value,
    );
    if (centroSelecionado) {
      setCartoesFiltrados(centroSelecionado[0]?.cartoes);
    }
  };

  const adicionarCartao = () => {
    const novosValores = cartao
      .map((item) => item.value)
      .filter(
        (novoCartao) =>
          !cartaoAdicionado.some(
            (cartaoExistente) =>
              cartaoExistente.nuCartao === novoCartao.nuCartao &&
              cartaoExistente.nuContrato === novoCartao.nuContrato,
          ),
      );

    setCartaoAdicionado([...cartaoAdicionado, ...novosValores]);
  };

  const deleteCartaoAdicionado = (nuCartao) => {
    const updatedItems = cartaoAdicionado.filter(
      (item) => item.nuCartao !== nuCartao,
    );
    setCartaoAdicionado(updatedItems);
  };

  const possuiAlteracaoNaLista = () => {
    const normalizarCartoes = (lista) =>
      [...(lista || [])]
        .map(
          (item) =>
            `${item.nuContrato || ''}|${item.coCentroCusto || ''}|${item.nuCartao || ''}`,
        )
        .sort((a, b) => a.localeCompare(b, 'pt-BR', { sensitivity: 'base' }));

    const cartoesAtuais = normalizarCartoes(cartaoAdicionado);
    const cartoesCarregados = normalizarCartoes(cartoesOriginais);

    return JSON.stringify(cartoesAtuais) !== JSON.stringify(cartoesCarregados);
  };

  const salvar = async () => {
    if (!possuiAlteracaoNaLista()) {
      abreAlertaDialog('Não houve alterações na lista de cartões.');
      return;
    }

    let dadosEnviar = {
      listaUsuarios: listaUsuario,
      listaCartoes: cartaoAdicionado,
      idCorreiosPF: dadosPerfil?.idCorreiosPF,
      perfil: dadosPerfil?.perfil,
    };
    const { response } = await request(
      PERMISSIONARIO_EDITAR_CARTOES(
        dadosEmpresa.idCorreios,
        dadosEnviar,
        ipAddress,
      ),
    );

    if (response.ok) {
      setCartoesOriginais([...cartaoAdicionado]);
      abreAlertaDialog('Cartões  atualizados com sucesso!');
      //chamaDelegacaoAcesso();
    }
  };
  return (
    <>
      <div className="conteudo permissao-contrato">
        <h1>Permissões</h1>

        <h6>{usuario.nome}</h6>

        <h2>
          <br />
          Adicionar cartões
        </h2>
        <div className="adicionar-cartoes elev1">
          <SelectContratos
            idCorreios={dadosEmpresa.idCorreios}
            dadosPerfil={dadosPerfil}
            inputRef={register}
            errors={errors}
            control={control}
            name="nuContrato"
            placeholder="Selecione"
            onChange={(contrato) => setContratoSelecionado(contrato)}
            mensagem="Nenhum contrato encontrado"
          />

          <Select
            options={
              contratoSelecionado && dadosCentroCusto
                ? [
                    { label: 'Selecione', value: '' },
                    ...dadosCentroCusto.map((item) => ({
                      value: item.coCentroCusto,
                      label: item.coCentroCusto,
                    })),
                  ]
                : [{ label: 'Centro Custo', value: '' }]
            }
            name="motivo"
            inputref={register}
            errors={errors}
            label="Centro de Custo"
            id="coCentroCusto"
            onChange={handleEscolherCentroCusto}
          />

          <MultiSelectCartoesPostagem
            options={
              contratoSelecionado && dadosCentroCusto && cartoesFiltrados
                ? [
                    ...cartoesFiltrados.map((item) => ({
                      value: item,
                      label: item.nuCartao,
                    })),
                  ]
                : []
            }
            inputRef={register}
            control={control}
            errors={errors}
            className="col-6"
            valor={cartao}
            aoMudar={setCartao}
          />

          <button className="btn-pre" onClick={() => adicionarCartao()}>
            Adicionar
          </button>
        </div>
        {cartaoAdicionado?.length > 10 && (
          <button className="btn-cont" onClick={() => salvar()}>
            <i className="ic-salvar"></i>Salvar cartões
          </button>
        )}
        <span className="mini">
          <b>Cartões adicionados:</b>
        </span>
        <div className="cartoes-adidicionados">
          {cartaoAdicionado?.map((item, index) => (
            <>
              <div className="card-cartao" key={item.nuCartao}>
                <div>
                  <span className="mini">Contrato:</span>
                  {item.nuContrato}
                </div>
                <div>
                  <span className="mini">Centro Custo:</span>
                  {item.coCentroCusto}
                </div>
                <div>
                  <span className="mini">Cartão Postagem:</span>
                  {item.nuCartao}
                </div>
                {item.descricaoStatus && item.descricaoStatus !== 'Null' && (
                  <div>
                    <span className="mini">Status:</span>
                    {item.descricaoStatus}
                  </div>
                )}
                <button
                  title="remover usuário"
                  className="btn-txt so-icone"
                  onClick={() => deleteCartaoAdicionado(item.nuCartao)}
                >
                  <i className="ic-excluir-circulo"></i>
                </button>
              </div>
            </>
          ))}
        </div>

        <button className="btn-cont" onClick={() => salvar()}>
          <i className="ic-salvar"></i>Salvar cartões
        </button>

        <hr />
        <div>
          <h2>Permissões a sistemas</h2>
          <p className="sem-margem">
            Conceda acesso também aos sistemas para as pessoas selecionadas
          </p>
        </div>
        <button className="btn-cont" onClick={() => abreModalSistamas()}>
          <i className="ic-monitor"></i>Sistemas
        </button>

        {sistemasSelecionados ? (
          <span className="legenda">
            {sistemasSelecionados?.length} sistemas selecionados
          </span>
        ) : (
          <span className="legenda">Nenhum sistema seleconado</span>
        )}

        <hr />

        <div className="btns-row">
          <button className="btn-txt" onClick={() => chamaDelegacaoAcesso()}>
            Voltar
          </button>
        </div>
      </div>

      <ModalDialog
        titulo="Selecionar Sistemas"
        id="modal-novo"
        aberto={modalAbertoSistemas}
        setAberto={setModalAbertoSistemas}
        opcaoFechar={false}
      >
        <FormSistemas
          acaoCancelar={() => setModalAbertoSistemas(false)}
          acaoFechar={fechar}
          dadosEmpresa={dadosEmpresa}
          dadosPerfil={dadosPerfil}
          listaUsuarios={listaUsuario}
          ipAddress={ipAddress}
          dadosGruposCadastrados={dadosGruposCadastrados}
          sistemasSelecionados={(sistema) => setSistemasSelecionados(sistema)}
        />
      </ModalDialog>
    </>
  );
};
export default TelaDelegacaoEdicao;
